import React from "react";
import { Card, CardBody, CardHeader } from "@heroui/card";
import { Logo } from "../Logo/Logo";
import { SpinnerLoading } from "@Oway-Inc/web-components";

export const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md mx-auto">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>

        <Card className="bg-gray-700/60 backdrop-blur-sm border border-gray-600/30 shadow-2xl rounded-3xl">
          <CardHeader className="pb-0 pt-8 px-8 flex justify-center">
            <div className="text-center space-y-3 w-full">
              <h1 className="text-2xl font-bold text-white tracking-tight">
                Loading Order
              </h1>
              <p className="text-gray-400 text-sm leading-relaxed max-w-sm mx-auto">
                Please wait while we fetch the order details...
              </p>
            </div>
          </CardHeader>

          <CardBody className="px-8 py-8 flex justify-center">
            <div className="flex justify-center w-full">
              <div className="w-12 h-12">
                <SpinnerLoading />
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};
